export default { 
    HOUR: "hou", 
    DAY: "day"
};